import { Group, Radio, Stack, Text } from '@mantine/core';
import type { IntakeAction, IntakeAnswers } from '../types';
import { SCREENING_QUESTIONS } from '../intakeFhirConstants';

interface StepScreeningProps {
  answers: IntakeAnswers;
  dispatch: React.Dispatch<IntakeAction>;
}

export function StepScreening({ answers, dispatch }: StepScreeningProps): JSX.Element {
  return (
    <Stack gap="lg">
      <Text size="sm" c="dimmed">
        Please answer each of the following questions. All responses are kept confidential.
      </Text>
      {SCREENING_QUESTIONS.map(({ field, label }) => (
        <Radio.Group
          key={field}
          value={answers[field] == null ? '' : String(answers[field])}
          onChange={(value) =>
            dispatch({ type: 'SET_SCREENING', payload: { field, value: value === 'true' } })
          }
        >
          <Stack gap={6}>
            <Text size="sm" fw={500}>
              {label}
            </Text>
            <Group gap="xl">
              <Radio value="true" label="Yes" />
              <Radio value="false" label="No" />
            </Group>
          </Stack>
        </Radio.Group>
      ))}
    </Stack>
  );
}
